export default "__VITE_ASSET__970c6a74__"